/* Officina theme — global JS (vanilla, no dependencies) */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Money ---------- */
  window.formatMoney = function (cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    const value = (cents / 100);
    const fmt = (n, dec, thou, decSep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    let out = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = fmt(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = fmt(value, 2, ' ', ','); break;
      default: out = fmt(value, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  window.showToast = function (msg) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  /* ---------- Drawers ---------- */
  const openDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = d.querySelector('button, a, input'); if (f) setTimeout(() => f.focus(), 50);
  };
  const closeDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.search-modal.is-open')) document.documentElement.style.overflow = '';
  };
  window.openDrawer = openDrawer; window.closeDrawer = closeDrawer;

  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.openDrawer); return; }
    const c = e.target.closest('[data-close-drawer]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer').id); return; }
    const so = e.target.closest('[data-open-search]');
    if (so) { e.preventDefault(); const m = $('#SearchModal'); if (m) { m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; setTimeout(() => $('input', m).focus(), 30); } }
    const sc = e.target.closest('[data-close-search]');
    if (sc) { e.preventDefault(); const m = $('#SearchModal'); if (m) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(d => closeDrawer(d.id));
    const m = $('#SearchModal'); if (m && m.classList.contains('is-open')) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  });

  /* ---------- Header scroll ---------- */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else { $$('.reveal').forEach(el => el.classList.add('is-in')); }

  /* ---------- Quantity ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.qty button'); if (!b) return;
    const input = b.parentElement.querySelector('input');
    const min = parseInt(input.min || '1', 10);
    let v = parseInt(input.value || '1', 10) + (b.dataset.dir === 'down' ? -1 : 1);
    if (v < min) v = min;
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  const cart = {
    async render() {
      try {
        const res = await fetch(`${window.theme.routes.cart}?section_id=cart-drawer`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('#CartDrawerContent');
        const cur = $('#CartDrawerContent');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        const count = doc.querySelector('#CartDrawerContent')?.dataset.count || '0';
        $$('.cart-count').forEach(el => { el.textContent = count; el.dataset.count = count; });
      } catch (err) { console.error(err); }
    },
    async add(formData) {
      const res = await fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || window.theme.strings.error);
      await this.render();
      return data;
    },
    async change(line, quantity) {
      const content = $('#CartDrawerContent'); if (content) content.classList.add('cart-drawer__loading');
      const res = await fetch(window.theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!res.ok) showToast(window.theme.strings.error);
      await this.render();
      if (content) content.classList.remove('cart-drawer__loading');
      if (document.body.classList.contains('template-cart')) window.location.reload();
    }
  };
  window.themeCart = cart;

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]'); if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn.querySelector('span');
    const orig = label ? label.textContent : btn.textContent;
    btn.setAttribute('aria-disabled', 'true'); if (label) label.textContent = '…';
    try {
      await cart.add(new FormData(form));
      if (form.dataset.afterAdd === 'cart') { window.location.href = window.theme.routes.cart; return; }
      if (form.dataset.afterAdd === 'checkout') { window.location.href = '/checkout'; return; }
      openDrawer('CartDrawer');
      showToast(window.theme.strings.added);
    } catch (err) { showToast(err.message); }
    btn.removeAttribute('aria-disabled'); if (label) label.textContent = orig;
  });

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]'); if (!rm) return;
    e.preventDefault(); cart.change(parseInt(rm.dataset.cartRemove, 10), 0);
  });
  document.addEventListener('change', (e) => {
    const q = e.target.closest('[data-cart-line]'); if (!q) return;
    cart.change(parseInt(q.dataset.cartLine, 10), parseInt(q.value, 10));
  });
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quick-add]'); if (!q) return;
    e.preventDefault(); e.stopPropagation();
    const fd = new FormData(); fd.append('id', q.dataset.quickAdd); fd.append('quantity', '1');
    q.setAttribute('aria-disabled', 'true');
    cart.add(fd).then(() => { openDrawer('CartDrawer'); showToast(window.theme.strings.added); }).catch(err => showToast(err.message)).finally(() => q.removeAttribute('aria-disabled'));
  });

  /* ---------- Hero slideshow ---------- */
  $$('[data-slideshow]').forEach((hero) => {
    const track = $('.hero__slides', hero); const slides = $$('.hero__slide', hero);
    if (slides.length < 2) return;
    const dots = $$('.hero__dots button', hero);
    let i = 0, timer; const autoplay = hero.dataset.autoplay === 'true'; const speed = parseInt(hero.dataset.speed || '5000', 10);
    const go = (n) => { i = (n + slides.length) % slides.length; track.style.transform = `translateX(-${i * 100}%)`; dots.forEach((d, k) => d.setAttribute('aria-current', k === i)); };
    const start = () => { if (autoplay) timer = setInterval(() => go(i + 1), speed); };
    const stop = () => clearInterval(timer);
    dots.forEach((d, k) => d.addEventListener('click', () => { stop(); go(k); start(); }));
    $('.hero__arrow--prev', hero)?.addEventListener('click', () => { stop(); go(i - 1); start(); });
    $('.hero__arrow--next', hero)?.addEventListener('click', () => { stop(); go(i + 1); start(); });
    let sx = 0; hero.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { stop(); go(dx < 0 ? i + 1 : i - 1); start(); } });
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Product: gallery + variants ---------- */
  $$('[data-product]').forEach((root) => {
    const data = JSON.parse($('[data-product-json]', root).textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]', root);
    const btn = $('[data-add-button]', form); const btnLabel = $('span', btn);
    const inventory = $('[data-inventory]', root);
    const slides = $$('.media-slide', root); const thumbs = $$('.product__thumbs button', root);
    const stickyPrice = $('[data-sticky-price]', root);

    const showMedia = (k) => {
      slides.forEach((s, j) => s.classList.toggle('is-active', j === k));
      thumbs.forEach((t, j) => t.classList.toggle('is-active', j === k));
      const t = thumbs[k]; if (t) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      slides.forEach((s, j) => { const v = s.querySelector('video'); if (v && j !== k) v.pause(); });
    };
    let cur = slides.findIndex(s => s.classList.contains('is-active')); if (cur < 0) cur = 0;
    thumbs.forEach((t, k) => t.addEventListener('click', () => { cur = k; showMedia(k); }));
    $('[data-gallery-prev]', root)?.addEventListener('click', () => { cur = (cur - 1 + slides.length) % slides.length; showMedia(cur); });
    $('[data-gallery-next]', root)?.addEventListener('click', () => { cur = (cur + 1) % slides.length; showMedia(cur); });
    const mm = $('.product__main-media', root); let tsx = 0;
    if (mm) { mm.addEventListener('touchstart', (e) => { tsx = e.touches[0].clientX; }, { passive: true }); mm.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - tsx; if (Math.abs(dx) > 40 && slides.length > 1) { cur = (dx < 0 ? cur + 1 : cur - 1 + slides.length) % slides.length; showMedia(cur); } }); }

    const selected = () => $$('fieldset', form).map(fs => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    const findVariant = (opts) => data.variants.find(v => v.options.every((o, k) => o === opts[k]));

    const updateAvailability = () => {
      const opts = selected();
      $$('fieldset', form).forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const match = data.variants.find(v => v.options.every((o, k) => (k === idx || test[k] === null) ? (k === idx ? o === inp.value : true) : o === test[k]));
          inp.classList.toggle('is-unavailable', !(match && match.available));
        });
      });
    };

    const update = () => {
      const v = findVariant(selected());
      $$('fieldset', form).forEach((fs) => { const c = fs.querySelector('input:checked'); const t = fs.querySelector('legend span'); if (c && t) t.textContent = c.value; });
      if (!v) { btn.setAttribute('aria-disabled', 'true'); btnLabel.textContent = window.theme.strings.unavailable; return; }
      idInput.value = v.id;
      const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (priceEl) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.classList.toggle('price--sale', !!sale);
        priceEl.innerHTML = `<span class="price__current">${formatMoney(v.price)}</span>` + (sale ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s><span class="price__save">-${Math.round((1 - v.price / v.compare_at_price) * 100)}%</span>` : '');
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (v.available) { btn.removeAttribute('aria-disabled'); btnLabel.textContent = window.theme.strings.addToCart; }
      else { btn.setAttribute('aria-disabled', 'true'); btnLabel.textContent = window.theme.strings.soldOut; }
      if (inventory) {
        const q = v.inventory_quantity; const managed = v.inventory_management === 'shopify';
        inventory.className = 'inventory';
        if (!v.available) { inventory.classList.add('inventory--out'); inventory.textContent = inventory.dataset.out; }
        else if (managed && q > 0 && q <= parseInt(inventory.dataset.threshold || '5', 10)) { inventory.classList.add('inventory--low'); inventory.textContent = inventory.dataset.low.replace('[[count]]', q); }
        else { inventory.textContent = inventory.dataset.in; }
      }
      if (v.featured_media) { const k = slides.findIndex(s => s.dataset.mediaId == v.featured_media.id); if (k >= 0) { cur = k; showMedia(k); } }
      updateAvailability();
    };
    form.addEventListener('change', (e) => { if (e.target.matches('fieldset input')) update(); });
    form.addEventListener('submit', (e) => { if (btn.getAttribute('aria-disabled') === 'true') e.preventDefault(); });
    updateAvailability();

    const sticky = $('.sticky-atc', root);
    if (sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
      io.observe(btn);
      $('[data-sticky-add]', sticky)?.addEventListener('click', () => { btn.click(); });
    }
  });

  /* ---------- Predictive search ---------- */
  const sInput = $('#SearchModal input[name="q"]'); const sResults = $('#PredictiveResults');
  if (sInput && sResults) {
    let t;
    sInput.addEventListener('input', () => {
      clearTimeout(t); const q = sInput.value.trim();
      if (q.length < 2) { sResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const res = await fetch(`${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
          const html = await res.text(); const doc = new DOMParser().parseFromString(html, 'text/html');
          sResults.innerHTML = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
        } catch (e) { /* ignore */ }
      }, 220);
    });
  }

  /* ---------- Collection filters / sort ---------- */
  const sortSel = $('[data-sort-by]');
  if (sortSel) sortSel.addEventListener('change', () => { const u = new URL(window.location); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); window.location = u; });
  const filterForm = $('#CollectionFilters');
  if (filterForm) {
    let ft;
    filterForm.addEventListener('change', () => { clearTimeout(ft); ft = setTimeout(() => filterForm.submit(), 350); });
  }

  /* ---------- Close details on outside click (desktop nav/filters) ---------- */
  document.addEventListener('click', (e) => {
    $$('.header-nav details[open], .filters details[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
})();
